export interface ConsultationBundle {
  id: string;
  name: string;
  consults: number;
  ticketPrice: number; // Bundle amount (what the user pays)
  discountPercent: number;
  discountPrice: number; // Equivalent discounted total
  consultPrice: number; // Effective price per consultation
  description?: string;
  popular?: boolean;
}

export const consultationBundles: ConsultationBundle[] = [
  {
    id: "launcher",
    name: "Launcher",
    consults: 100,
    ticketPrice: 150,
    discountPercent: 10,
    discountPrice: 135,
    consultPrice: 1.35,
    description: "Great for small teams getting started",
  },
  {
    id: "explorer",
    name: "Explorer",
    consults: 250,
    ticketPrice: 375,
    discountPercent: 20,
    discountPrice: 300,
    consultPrice: 1.2,
    description: "Ideal for growing pharmacies",
    popular: true,
  },
  {
    id: "voyager",
    name: "Voyager",
    consults: 500,
    ticketPrice: 750,
    discountPercent: 30,
    discountPrice: 525,
    consultPrice: 1.05,
    description: "For high-volume consultation services",
  },
  {
    id: "conqueror",
    name: "Conqueror",
    consults: 1000,
    ticketPrice: 1500,
    discountPercent: 40,
    discountPrice: 900,
    consultPrice: 0.9,
    description: "Maximum savings for enterprise pharmacies",
  },
];
